import React, { Component } from "react";

export default class footer extends Component {
  render() {
    return (
      <>
        <div class="footer out-footer">
          <div class="copyright">
            <p>
              Copyright © by
              <a href="https://bajizone.live" target="_blank">
                bajizone.live
              </a>
              2026
            </p>
          </div>
        </div>
      </>
    );
  }
}
